import { useState } from "react";

import { HoverDiagnosticsPanel } from "@/components/hover-diagnostics/HoverDiagnosticsPanel";
import { useHoverDiagnostics } from "@/components/hover-diagnostics/useHoverDiagnostics";

export function HoverDiagnostics({ enabled }: { enabled: boolean }) {
  const [visible, setVisible] = useState(true);

  // Always call hook unconditionally to satisfy Rules of Hooks
  const { snapshot, captureNow, armed, armPick, copySnapshot, copyState, fallbackText } = useHoverDiagnostics({ enabled });

  if (!enabled || !visible) return null;

  return (
    <HoverDiagnosticsPanel
      snapshot={snapshot}
      armed={armed}
      onPick={armPick}
      copyState={copyState}
      fallbackText={fallbackText}
      onCapture={captureNow}
      onCopy={copySnapshot}
      onClose={() => setVisible(false)}
    />
  );
}
